import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import { formatDateString } from "./fulfillment-group-csv-utils";

export const ShippedDateCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipped date",
    cell: (row) => {
      return row.status === FulfillmentGroupStatus.Closed
        ? formatDateString(row.fulfillmentInfo?.shipDate?.toISOString())
        : "";
    },
  };
